import { render, staticRenderFns } from "./self-lottery-bet-time.vue?vue&type=template&id=219db74c&"
import script from "./self-lottery-bet-time.vue?vue&type=script&lang=js&"
export * from "./self-lottery-bet-time.vue?vue&type=script&lang=js&"
import style0 from "./self-lottery-bet-time.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports